import { getApiFunctions } from "../api";

// ================== cloud ================ //
export const downloadFile =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().client.clientAutoDelete;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Lỗi không xác định" });
      });
  };

export const forceDelete =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().client.clientForceDelete;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Lỗi không xác định" });
      });
  };

export const cancelDelete =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().client.clientCancelDelete;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Lỗi không xác định" });
      });
  };
